import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useSelector, shallowEqual, useDispatch } from 'react-redux';
import ClipLoader from 'react-spinners/ClipLoader';
import MediaCategoryForm from 'components/MediaCategoryForm';
import {
  createMediaCategory,
  modifyMediaCategory,
  fetchMediaCategories,
} from 'state/actions/mediaCategories';
import { useFormatMessage } from '@/hooks';

const MediaCategory = ({ history }) => {
  const { id } = useParams();

  const {
    success,
    categoriesList,
    categoryData,
    sitesList,
    error,
  } = useSelector(
    (state) => ({
      success: state.mediaCategories.success,
      categoriesList: state.mediaCategories.list,
      categoryData: state.mediaCategories.category,
      sitesList: state.sites.list,
      error: state.mediaCategories.error,
    }),
    shallowEqual
  );

  const [category, setCategory] = useState(categoryData || {});

  const dispatch = useDispatch();

  useEffect(() => {
    if (id) {
      const categoryFetched = categoriesList.find(
        (fetchedCategory) => fetchedCategory._id === id
      );
      if (categoryFetched) {
        setCategory(categoryFetched);
      } else if (categoryData.id === id) {
        setCategory(categoryData);
      } else {
        dispatch(fetchMediaCategories(id));
      }
    }
  }, [id, categoryData]); // eslint-disable-line react-hooks/exhaustive-deps

  const isEditing = !!id;

  const categoryForm =
    !category && id ? (
      <ClipLoader />
    ) : (
      <MediaCategoryForm
        isEditing={isEditing}
        category={category}
        sites={sitesList}
        success={success}
        history={history}
        setCategory={setCategory}
        action={isEditing ? modifyMediaCategory : createMediaCategory}
        id={id}
        error={error}
      />
    );

  // const redirect = (error || success) && <Redirect to={paths.USERS} />;

  const editCategoryMessage = useFormatMessage('Category.editCategory');

  const newCategoryMessage = useFormatMessage('Category.newCategory');

  return (
    <>
      {/* {redirect} */}
      <section className="hero is-hero-bar">
        <div className="hero-body">
          <h1 className="title">
            {isEditing ? editCategoryMessage : newCategoryMessage}
          </h1>
        </div>
      </section>
      <section className="section is-main-section">{categoryForm}</section>
    </>
  );
};

export default MediaCategory;
